import { Injectable } from '@angular/core';
import { INDRAApiService } from './api.indra.service';
import { INDRAPax } from '@ibe.models/pax.indra.model.lib';
import { URL_ROOT } from '@ibe.config';

@Injectable({
  providedIn: 'root'
})
export class PassengerContactsService {

	constructor(
		private apiService: INDRAApiService
	) { }

	public updateContacts(data: INDRAPax, pnr: string, passenger_id: number) {
		const URL = `${URL_ROOT}booking/pnrs/${pnr}/passengers/${passenger_id}/contacts/update`;
		const rq = {
			emails: [
				data.email
			],
			pnr: pnr,
			idPax: passenger_id,
			telephones: [{
				number: data.phone,
				prefix: data.phoneCountryCode,
				type: data.phoneType
			}]
		};
		return this.apiService.INDRA_put(URL, rq);
	}
}
